"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _ramda = require("ramda");

var _reactContentLoader = require("react-content-loader");

var _reactContentLoader2 = _interopRequireDefault(_reactContentLoader);

var _reactIntl = require("react-intl");

var _propTypes = require("./propTypes");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Installments = require("./Installments");

var _Installments2 = _interopRequireDefault(_Installments);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/**
 * The Price component. Shows the prices information of the Product Summary.
 */


var Price = /*#__PURE__*/function (_Component) {
  _inherits(Price, _Component);

  function Price(props) {
    var _this;

    _classCallCheck(this, Price);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Price).call(this, props));
    _this.currencyOptions = {
      style: 'currency',
      currency: props.currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    };
    return _this;
  }

  _createClass(Price, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          sellingPrice = _this$props.sellingPrice,
          listPrice = _this$props.listPrice,
          unavailable = _this$props.unavailable,
          showListPrice = _this$props.showListPrice,
          showInstallments = _this$props.showInstallments,
          showLabels = _this$props.showLabels,
          showSavings = _this$props.showSavings,
          showStartingAt = _this$props.showStartingAt,
          labelSellingPrice = _this$props.labelSellingPrice,
          className = _this$props.className,
          loaderClass = _this$props.loaderClass,
          listPriceContainerClass = _this$props.listPriceContainerClass,
          listPriceLabelClass = _this$props.listPriceLabelClass,
          listPriceClass = _this$props.listPriceClass,
          sellingPriceContainerClass = _this$props.sellingPriceContainerClass,
          sellingPriceLabelClass = _this$props.sellingPriceLabelClass,
          sellingPriceClass = _this$props.sellingPriceClass,
          savingsContainerClass = _this$props.savingsContainerClass,
          savingsClass = _this$props.savingsClass,
          installments = _this$props.installments,
          installmentClass = _this$props.installmentClass,
          interestRateClass = _this$props.interestRateClass,
          installmentContainerClass = _this$props.installmentContainerClass,
          startingAtClass = _this$props.startingAtClass,
          unavailableClass = _this$props.unavailableClass,
          styles = _this$props.styles,
          formatNumber = _this$props.intl.formatNumber;

      if (showListPrice && (0, _ramda.isNil)(listPrice) || (0, _ramda.isNil)(sellingPrice)) {
        return _react2["default"].createElement(Price.Loader, _extends({
          loaderClass: loaderClass
        }, styles));
      }

      if (unavailable) return _react2["default"].createElement("div", {
        className: unavailableClass
      }, _react2["default"].createElement(_reactIntl.FormattedMessage, {
        id: "pricing.unavailable"
      }));
      var differentPrices = showListPrice && sellingPrice !== listPrice;
      return _react2["default"].createElement("div", {
        className: (0, _classnames2["default"])('vtex-price', className)
      }, differentPrices && _react2["default"].createElement("div", {
        className: (0, _classnames2["default"])('vtex-price-list__container', listPriceContainerClass)
      }, showLabels && _react2["default"].createElement("div", {
        className: (0, _classnames2["default"])('vtex-price-list__label', listPriceLabelClass)
      }, _react2["default"].createElement(_reactIntl.FormattedMessage, {
        id: "pricing.from"
      })), _react2["default"].createElement("span", {
        className: (0, _classnames2["default"])('vtex-price-list', listPriceClass)
      }, formatNumber(listPrice, this.currencyOptions))), _react2["default"].createElement("div", {
        className: (0, _classnames2["default"])('vtex-price-selling__container', sellingPriceContainerClass)
      }, showLabels && _react2["default"].createElement("div", {
        className: (0, _classnames2["default"])('vtex-price-selling__label', sellingPriceLabelClass)
      }, labelSellingPrice || _react2["default"].createElement(_reactIntl.FormattedMessage, {
        id: "pricing.to"
      })), showStartingAt && _react2["default"].createElement("span", {
        className: (0, _classnames2["default"])('vtex-price-selling__from-tag', startingAtClass)
      }, _react2["default"].createElement(_reactIntl.FormattedMessage, {
        id: "pricing.startingAtLabel"
      }), ' '), _react2["default"].createElement("div", {
        className: (0, _classnames2["default"])('vtex-price-selling', sellingPriceClass)
      }, formatNumber(sellingPrice, this.currencyOptions))), showInstallments && _react2["default"].createElement(_Installments2["default"], {
        installments: installments,
        showLabels: showLabels,
        formatNumber: formatNumber,
        currencyOptions: this.currencyOptions,
        className: installmentContainerClass,
        interestRateClass: interestRateClass,
        installmentClass: installmentClass
      }), differentPrices && showSavings && _react2["default"].createElement("div", {
        className: (0, _classnames2["default"])('vtex-price-savings__container', savingsContainerClass)
      }, _react2["default"].createElement("div", {
        className: (0, _classnames2["default"])('vtex-price-savings', savingsClass)
      }, _react2["default"].createElement(_reactIntl.FormattedMessage, {
        id: "pricing.savings",
        values: {
          savings: formatNumber(listPrice - sellingPrice, this.currencyOptions)
        }
      }))));
    }
  }]);

  return Price;
}(_react.Component);

_defineProperty(Price, "propTypes", _propTypes2["default"]);

_defineProperty(Price, "defaultProps", {
  showListPrice: true,
  showLabels: true,
  showInstallments: false,
  showSavings: false,
  labelSellingPrice: null
});

Price.Loader = function () {
  var loaderProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var loaderClass = loaderProps.loaderClass,
      filteredLoaderProps = _objectWithoutProperties(loaderProps, ["loaderClass"]);

  return _react2["default"].createElement("div", {
    className: (0, _classnames2["default"])('vtex-price vtex-price-loader', loaderClass)
  }, _react2["default"].createElement(_reactContentLoader2["default"], _extends({
    style: {
      width: '100%',
      height: '100%'
    },
    width: 300,
    height: 70,
    preserveAspectRatio: "xMinYMin meet"
  }, filteredLoaderProps), _react2["default"].createElement("rect", _extends({
    height: "0.75em",
    width: "50%",
    x: "25%"
  }, filteredLoaderProps['vtex-price-list__container--loader'])), _react2["default"].createElement("rect", filteredLoaderProps['vtex-price-selling__label--loader']), _react2["default"].createElement("rect", _extends({
    height: "1em",
    width: "70%",
    x: "15%",
    y: "1.25em"
  }, filteredLoaderProps['vtex-price-selling--loader'])), _react2["default"].createElement("rect", _extends({
    height: "0.75em",
    width: "80%",
    x: "10%",
    y: "2.75em"
  }, filteredLoaderProps['vtex-price-installments--loader'])), _react2["default"].createElement("rect", filteredLoaderProps['vtex-price-savings--loader'])));
};

Price.Loader.displayName = 'Price.Loader';
var priceWithIntel = (0, _reactIntl.injectIntl)(Price);
priceWithIntel.schema = {
  title: 'editor.productPrice.title',
  description: 'editor.productPrice.description',
  type: 'object',
  properties: {
    labelSellingPrice: {
      type: 'string',
      title: 'editor.productPrice.labelSellingPrice',
      "default": Price.defaultProps.labelSellingPrice,
      isLayout: true
    },
    showListPrice: {
      type: 'boolean',
      title: 'editor.productPrice.showListPrice',
      "default": Price.defaultProps.showListPrice,
      isLayout: true
    },
    showLabels: {
      type: 'boolean',
      title: 'editor.productPrice.showLabels',
      "default": Price.defaultProps.showLabels,
      isLayout: true
    },
    showInstallments: {
      type: 'boolean',
      title: 'editor.productPrice.showInstallments',
      "default": Price.defaultProps.showInstallments,
      isLayout: true
    },
    showSavings: {
      type: 'boolean',
      title: 'editor.productPrice.showSavings',
      "default": Price.defaultProps.showSavings,
      isLayout: true
    }
  }
};
exports["default"] = priceWithIntel;